import { connect } from 'react-redux';

import Login from '~/Components/Pages/Login/Login';

import { fetchAll } from '~/Services/Container';

import {
  handleLogin,
  updateField,
  handleGoogleLogin,
  handleAppleLogin,
} from '~/Redux/Modules/Auth';

const mapStateToProps = ({ Auth }) => {
  return {
    isAuthenticated: Auth.isAuthenticated,
    isFetching: Auth.isLogging,
    hasFetched: Auth.hasFetched,
    current: Auth.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAll: () => fetchAll(), //pass dispatches
    handleLogin: (data, redirect) => {
      return dispatch(handleLogin(data, redirect));
    },
    handleGoogleLogin: (data, redirect) => {
      return dispatch(handleGoogleLogin(data, redirect));
    },
    handleAppleLogin: (data, redirect) => {
      return dispatch(handleAppleLogin(data, redirect));
    },
    updateField: data => {
      return dispatch(updateField(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
